import { render, staticRenderFns } from "./HowToUseAMoxaBox.vue?vue&type=template&id=47754cc5&"
import script from "./HowToUseAMoxaBox.vue?vue&type=script&lang=js&"
export * from "./HowToUseAMoxaBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports